import { format } from "date-fns";
import { UTCDateMini } from "@date-fns/utc/date/mini";

export function formatHash(hash: string): string {
  return `${hash.substring(0, 5)}...${hash.substring(hash.length - 3, hash.length)}`;
}

export function formatAddress(address: string): string {
  return `${address.substring(0, 7)}...${address.substring(address.length - 7, address.length)}`;
}

export function formatNumber(value: number | bigint) {
  return Intl.NumberFormat().format(value);
}

export function formatCurrency(value: number | bigint, { maxFractionDigits = 2, minFractionDigits = 0 }: { maxFractionDigits?: number; minFractionDigits?: number } = {}) {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: maxFractionDigits,
    minimumFractionDigits: minFractionDigits,
  }).format(value);
}

export function formatPercent(value: number, { maxFractionDigits = 2, minFractionDigits = 0 }: { maxFractionDigits?: number; minFractionDigits?: number } = {}) {
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    notation: "compact",
    maximumFractionDigits: maxFractionDigits,
    minimumFractionDigits: minFractionDigits,
  }).format(value);
}

// SEPTEMBER 31 2023 05:38:35 AM
export function formatTimestamp(value: number) {
  return format(new UTCDateMini(value), "MMMM d y pp O");
}
